<template>
    <div v-if="isLoaded">
        <div class="content-body">
            <div class="row match-height">
                <div class="col-xl-12 col-lg-12">
                    <div class="card" style="">
                        <div class="card-header" style="display:flex; justify-content:space-between">
                            <h4 class="card-title">Importação de Documentos EDI</h4>
                            <button type="button" class="btn btn-secondary btn-outline" @click="onImport">Importar</button>
                        </div>
                    </div>
                </div>
            </div>
            <ImportacaoModal ref="importacaomodal" />
        </div>
    </div>
</template>

<script>
import ImportacaoModal from '../components/ImportacaoModal'
export default {
    components: {
        ImportacaoModal,
    },
    data () {
        return {
            showModal: false,
        }
    },
    methods: {      
        onImport(){
            this.$refs.importacaomodal.onImport();
        }
    },
    computed: {
        isLoaded: {
            get() {
                return this.$store.getters.isloaded;
            }
        }
    }
}
</script>
